import { connect } from "react-redux"
import DangerZone from "./DangerZone"
import { withRouter } from "react-router"
import { compose } from "redux"

const mapStateToProps = (state, _props) => ({
	userPrivileges: state.user.privileges,
})

const mapDispatchToProps = (_dispatch, _props) => ({})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(DangerZone)
